import Dispatcher from '../../dispatcher';
import HttpRequestConstants from '../../constants/http_request';
import HTTP_REQUEST_KEYS from '../../constants/http_request_keys';

function shippingOptionsComputeStarted() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_STARTED,
  });
}

function shippingOptionsComputeSuccess() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_SUCCESS,
  });
}

function shippingOptionsComputeFailed() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_FAILED,
  });
}

function shippingOptionsComputeReset() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.RESET_STATUS,
    payload: HTTP_REQUEST_KEYS.CART_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE,
  });
}


export {
  shippingOptionsComputeStarted,
  shippingOptionsComputeSuccess,
  shippingOptionsComputeFailed,
  shippingOptionsComputeReset,
};
